import styled from 'styled-components'

const StyledCoursePreviewVideo = styled.div`
  background-color: rgb(0, 0, 0);
  border-radius: 6px 6px 0 0;
  position: relative;
  overflow: hidden;
`

export default StyledCoursePreviewVideo
